enum MultiPinGroupMode {
  WITHIN_GROUP = "within",
  OUTSIDE_GROUP = "outside",
}

export default MultiPinGroupMode;
